import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.h2`
	color: ${helpers.color.text};
	background-color: ${helpers.color.subtitleBackground};
	font-size: ${helpers.font.size.subheader};
	font-family: ${helpers.font.family.header};
	font-weight: 400;
	padding: 32px 16px 16px;
`
